"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RightArrow;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function RightArrow() {
  return _react2.default.createElement("svg", {
    fill: "#576574",
    width: "6.46px",
    height: "10px",
    viewBox: "0 0 6.46 10",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react2.default.createElement("path", {
    d: "M6.22049689,5.52795031 L1.99689441,9.7515528 C1.70496894,10.0434783 1.23291925,10.0434783 0.944099379,9.7515528 L0.242236025,9.04968944 C-0.049689441,8.75776398 -0.049689441,8.28571429 0.242236025,7.99689441 L3.23602484,5.00310559 L0.242236025,2.00931677 C-0.049689441,1.7173913 -0.049689441,1.24534161 0.242236025,0.956521739 L0.940993789,0.248447205 C1.23291925,-0.0434782609 1.70496894,-0.0434782609 1.99378882,0.248447205 L6.2173913,4.47204969 C6.51242236,4.76397516 6.51242236,5.23602484 6.22049689,5.52795031 Z"
  }));
}